module.exports = __webpack_public_path__ + "static/media/banner-advertisers.90772d79.jpg";